// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Moment = require("moment");

var Duration = {};

function add(duration, moment) {
  var c = moment.clone();
  c.add(duration);
  return c;
}

function subtract(duration, moment) {
  var c = moment.clone();
  c.subtract(duration);
  return c;
}

function startOf(unit, moment) {
  var c = moment.clone();
  c.startOf(unit);
  return c;
}

function endOf(unit, moment) {
  var c = moment.clone();
  c.endOf(unit);
  return c;
}

function setMillisecond(ms, m) {
  var c = m.clone();
  c.millisecond(ms);
  return c;
}

function setSecond(s, m) {
  var c = m.clone();
  c.second(s);
  return c;
}

function setMinute(v, m) {
  var c = m.clone();
  c.minute(v);
  return c;
}

function setHour(v, m) {
  var c = m.clone();
  c.hour(v);
  return c;
}

function setDate(v, m) {
  var c = m.clone();
  c.date(v);
  return c;
}

function setDay(v, m) {
  var c = m.clone();
  c.day(v);
  return c;
}

function setWeekday(v, m) {
  var c = m.clone();
  c.weekday(v);
  return c;
}

function setIsoWeekday(v, m) {
  var c = m.clone();
  c.isoWeekday(v);
  return c;
}

function setDayOfYear(v, m) {
  var c = m.clone();
  c.dayOfYear(v);
  return c;
}

function setWeek(v, m) {
  var c = m.clone();
  c.week(v);
  return c;
}

function setIsoWeek(v, m) {
  var c = m.clone();
  c.isoWeek(v);
  return c;
}

function setQuarter(v, m) {
  var c = m.clone();
  c.quarter(v);
  return c;
}

function setWeekYear(v, m) {
  var c = m.clone();
  c.weekYear(v);
  return c;
}

function setIsoWeekYear(v, m) {
  var c = m.clone();
  c.isoWeekYear(v);
  return c;
}

function setMonth(v, m) {
  var c = m.clone();
  c.month(v);
  return c;
}

function setYear(v, m) {
  var c = m.clone();
  c.year(v);
  return c;
}

var Moment$1 = {
  add: add,
  subtract: subtract,
  startOf: startOf,
  endOf: endOf,
  setMillisecond: setMillisecond,
  setSecond: setSecond,
  setMinute: setMinute,
  setHour: setHour,
  setDate: setDate,
  setDay: setDay,
  setWeekday: setWeekday,
  setIsoWeekday: setIsoWeekday,
  setDayOfYear: setDayOfYear,
  setWeek: setWeek,
  setIsoWeek: setIsoWeek,
  setQuarter: setQuarter,
  setWeekYear: setWeekYear,
  setIsoWeekYear: setIsoWeekYear,
  setMonth: setMonth,
  setYear: setYear
};

function momentWithUnix(ts) {
  return Moment(ts * 1000.0);
}

function momentUtc(format, value) {
  if (format !== undefined) {
    return Moment.utc(value, format);
  } else {
    return Moment.utc(value);
  }
}

function moment(format, value) {
  if (format !== undefined) {
    return Moment(value, format);
  } else {
    return Moment(value);
  }
}

exports.Duration = Duration;
exports.Moment = Moment$1;
exports.momentWithUnix = momentWithUnix;
exports.momentUtc = momentUtc;
exports.moment = moment;
/* moment Not a pure module */
